export default "//static.tradera.net/touchweb/static/output/images/app-store-badge-nl.576fd4c9.svg";